<!-- status-acronym-tooltip.component.html -->
<mat-card class="status-acronym-card">
  <mat-card-header>
    <mat-card-title>Status Codes</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <div class="acronym-list">
      <div *ngFor="let acronym of acronymList" class="acronym-item">
        <div class="icon-container">
          <!-- Use the icon directly from the backend response -->
          <img class="status-icon" src="{{ acronym.icon }}" />
        </div>
        <div class="acronym-text">
          <span class="acronym-code">{{acronym.code}}</span>
          <span class="acronym-description">&nbsp;&nbsp; {{acronym.description}}</span>
        </div>
      </div>
    </div>
  </mat-card-content>
</mat-card>
